import axios from "axios";
import { actionUnauthorized, setToken } from "../Redux/Slices/userSlice";
import { store } from "../Redux/store";
import { AuthenticationService } from "../Services/AuthenticationService";


//Request interceptor
axios.interceptors.request.use(
    (config) => {
        const state = store.getState();
        let currentUser = state.user;
        const token = currentUser.token;
        if (token) {
            config.headers!["Authorization"] = "Bearer " + token;
        }
        config.headers!["Content-Type"] = "application/json";

        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

//Response interceptor
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const originalRequest = error.config;
        //If unautherised try refresh token.
        //TODO check if status = 403 when token expires,
        //i had to relog because i was getting 403 and the token wasnt refreshing?
        if (
            error.response.status === 401 &&
            !originalRequest._retry
        ) {
            //console.log("refreshing");
            /*
            return getToken(originalRequest).then((newConfig) => {
                newConfig._retry = true;
                return Promise.resolve(axios(newConfig));
            })*/
            //AuthenticationService.logout();
            store.dispatch(actionUnauthorized());
            return Promise.resolve();
        } else {
            if (error.response.status === 401) {
                //return Promise.resolve();
                //AuthenticationService.logout();
                store.dispatch(actionUnauthorized());
                return Promise.resolve();
            }
        }
        return Promise.reject(error);
    }
);